module.exports = __webpack_public_path__ + "static/media/pennies-1900.173fa344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pond/pennies-1900.jpg
// module id = 344
// module chunks = 31